import { colors, defaultStyles } from "./colors";
import { createTheme } from "@mui/material/styles";

const BaseTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: defaultStyles.borderRadius,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          ":-webkit-autofill": {
            borderRadius: "inherit",
          },
        },
      },
    },
  },
  palette: {
    primary: {
      light: colors.main,
      main: colors.mainDark,
      contrastText: colors.main,
    },
    secondary: {
      main: colors.white,
    },
    success: {
      main: colors.success,
      light: colors.buttonBackground,
    },
    error: {
      main: colors.error,
      light: colors.error,
    },
    text: {
      primary: colors.textDark,
    },
    background: {
      default: colors.siteBackground,
      paper: colors.siteBackground,
    },
    common: {
      black: colors.textDark,
      white: colors.white,
    },
  },
  typography: {
    //prevents defaulting to MUI defaults (Roboto, Helvetica, Arial, sans-serif)
    fontFamily: "Inter, Arial, sans-serif",

    h1: { fontFamily: "Antonio, Arial, sans-serif" },
    h2: { fontFamily: "Antonio, Arial, sans-serif" },
    //h3 used as center header in superheaders (it-consultant, consulting-management etc, uppercase requested)
    h3: { fontFamily: "Antonio, Arial, sans-serif", textTransform: "uppercase" },
    h4: { fontFamily: "Antonio, Arial, sans-serif" },
    h5: { fontFamily: "Archivo Narrow, Antonio, Arial, sans-serif" },
    h6: { fontFamily: "Antonio, Arial, sans-serif" },

    body1: { fontFamily: "Inter, Arial, sans-serif", letterSpacing: "-0.01em" },
    body2: { fontFamily: "Inter, Arial, sans-serif", letterSpacing: "-0.01em" },

    subtitle1: {
      fontFamily: "Archivo Narrow, Arial, sans-serif",
      letterSpacing: "0.01em",
    },
    subtitle2: {
      fontFamily: "Archivo Narrow, Arial, sans-serif",
      letterSpacing: "0.02em",
    },

    caption: { fontFamily: "Archivo Narrow, Inter, Arial, sans-serif" },
    overline: { fontFamily: "Inter, Arial, sans-serif" },
    button: {
      textTransform: "none",
    },
  },
});

export default BaseTheme;
